import { useEffect, useState } from "react";
import { Loader2, TrendingUp, ShoppingBag, Users, Building2, Image, Headphones } from "lucide-react";
import { api } from "../../api";

const STATS_CONFIG = [
  { key: "revenue_eur", label: "Entrate", icon: TrendingUp, color: "#10B981", format: (v) => `€${Number(v || 0).toFixed(2)}` },
  { key: "purchases", label: "Acquisti", icon: ShoppingBag, color: "#0B4A99", format: (v) => v ?? 0 },
  { key: "users", label: "Utenti", icon: Users, color: "#7C3AED", format: (v) => v ?? 0 },
  { key: "total_plays", label: "Ascolti", icon: Headphones, color: "#D97706", format: (v) => v ?? 0 },
  { key: "museums", label: "Musei", icon: Building2, color: "#0891B2", format: (v) => v ?? 0 },
  { key: "artworks", label: "Opere", icon: Image, color: "#E11D48", format: (v) => v ?? 0 },
];

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [purchases, setPurchases] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([api.adminStats(), api.adminPurchases()])
      .then(([s, p]) => { setStats(s); setPurchases(p.items || []); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="p-10 flex items-center justify-center"><Loader2 className="animate-spin text-brand" /></div>;

  return (
    <div className="p-8 page-enter">
      <h1 className="font-heading font-bold text-4xl text-ink mb-1">Dashboard</h1>
      <p className="text-sm text-ink-soft mb-8">Panoramica delle entrate e dell'attività.</p>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-10">
        {STATS_CONFIG.map(({ key, label, icon: Icon, color, format }) => (
          <div key={key} data-testid={`stat-${key}`} className="bg-white border border-border rounded-2xl p-5 hover:shadow-md transition">
            <div className="flex items-center justify-between mb-3">
              <div className="text-[11px] tracking-widest font-semibold text-ink-soft">{label.toUpperCase()}</div>
              <div className="w-9 h-9 rounded-xl flex items-center justify-center" style={{ backgroundColor: `${color}15`, color }}>
                <Icon size={18} />
              </div>
            </div>
            <div className="font-heading font-bold text-3xl text-ink tabular-nums">
              {format(stats?.[key])}
            </div>
          </div>
        ))}
      </div>

      <div className="bg-white border border-border rounded-2xl overflow-hidden">
        <div className="px-5 py-4 border-b border-border">
          <h2 className="font-semibold text-lg text-ink">Vendite recenti</h2>
        </div>
        {purchases.length === 0 ? (
          <div className="p-8 text-center text-sm text-ink-soft">Nessuna vendita ancora</div>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-bg/50">
              <tr className="text-left">
                <th className="px-5 py-3 text-[11px] tracking-widest font-semibold text-ink-soft">DATA</th>
                <th className="px-5 py-3 text-[11px] tracking-widest font-semibold text-ink-soft">TIPO</th>
                <th className="px-5 py-3 text-[11px] tracking-widest font-semibold text-ink-soft">DESCRIZIONE</th>
                <th className="px-5 py-3 text-[11px] tracking-widest font-semibold text-ink-soft text-right">IMPORTO</th>
              </tr>
            </thead>
            <tbody>
              {purchases.slice(0, 15).map((p) => (
                <tr key={p.id} className="border-t border-border hover:bg-bg/40">
                  <td className="px-5 py-3 text-ink-soft tabular-nums">{new Date(p.created_at).toLocaleDateString("it-IT")}</td>
                  <td className="px-5 py-3">
                    <span className="inline-block px-2 py-0.5 rounded-full bg-brand/10 text-brand text-[11px] font-semibold tracking-wider">
                      {p.kind?.toUpperCase()}
                    </span>
                  </td>
                  <td className="px-5 py-3 text-ink">{p.label}</td>
                  <td className="px-5 py-3 text-right font-semibold text-ink tabular-nums">€{Number(p.amount).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
